module.exports = "/assets/logo_sg_aftereffects_1_1-cce4942f0b12218bb351d7c97d455c6f.png";